import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
import DialogPanelFooter from '../dialog-panel/dialog-panel-footer/dialog-panel-footer';
import NewButton from '../button/newButton';
import ProposeChangeDatePicker from '../datepicker-box/propose-change-date-picker';
import './bulk-action.scss';

function PerformBulkActions({ onCancelClick, translate, handleSubmit }) {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const validationSchema = Yup.object({
    cargoReadyDate: Yup.date()
      .nullable()
      .required(
        translate('manageordersscreen.scheduleDeliverySection.dueDateRequired')
      ),
    cargoDeliveryDate: Yup.date()
      .nullable()
      .required(
        translate(
          'manageordersscreen.scheduleDeliverySection.deliveryDateRequired'
        )
      )
      .min(
        Yup.ref('cargoReadyDate'),
        translate('manageordersscreen.scheduleDeliverySection.greaterError')
      ),
  });
  return (
    <div className="accept-dailog">
      <DialogPanel title="Cargo Ready & Delivery Date">
        <Formik
          initialValues={{
            cargoReadyDate: null,
            cargoDeliveryDate: null,
          }}
          validationSchema={validationSchema}
          validateOnMount={true}
          onSubmit={(values) => {
            handleSubmit(
              'Accepted',
              values.cargoReadyDate,
              values.cargoDeliveryDate
            );
          }}
        >
          {({ values, errors, touched, setFieldValue, setFieldTouched }) => {
            useEffect(() => {
              if (values.cargoReadyDate && values.cargoDeliveryDate) {
                setIsSubmitDisabled(false);
              } else {
                setIsSubmitDisabled(true);
              }
            }, [values.cargoReadyDate, values.cargoDeliveryDate]);
            return (
              <Form>
                <DialogPanelBody>
                  <p className="accept-description">
                    Would you like to mark 3 items as accepted? The chosen date
                    will apply to all 3 items.
                  </p>

                  <div className="date-container d-flex justify-between w-100 mb-25">
                    <div className="form-row justify-between mb-20 w-100">
                      <div className="form-column">
                        <div className="label-container">
                          <label>Expected Cargo Ready</label>
                        </div>
                        <ProposeChangeDatePicker
                          placeholder="DD/MM/YYYY"
                          selectedDate={values.cargoReadyDate}
                          onChange={(e) => {
                            setFieldValue('cargoReadyDate', e || null);
                            setFieldTouched('cargoReadyDate', true, false);
                          }}
                          errorMessage={
                            errors.cargoReadyDate && touched.cargoReadyDate
                              ? errors.cargoReadyDate
                              : ''
                          }
                          required
                        />
                      </div>
                      <div className="form-column">
                        <div className="label-container">
                          <label>Delivery Date</label>
                        </div>

                        <ProposeChangeDatePicker
                          placeholder="DD/MM/YYYY"
                          selectedDate={values.cargoDeliveryDate}
                          onChange={(e) => {
                            setFieldValue('cargoDeliveryDate', e || null);
                            setFieldTouched('cargoDeliveryDate', true, false);
                          }}
                          errorMessage={
                            errors.cargoDeliveryDate &&
                            touched.cargoDeliveryDate
                              ? errors.cargoDeliveryDate
                              : ''
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>
                </DialogPanelBody>
                <DialogPanelFooter>
                  <NewButton color="cancel" onClick={onCancelClick}>
                    {translate(
                      'manageordersscreen.scheduleDeliverySection.onClickCancel'
                    )}
                  </NewButton>
                  <NewButton
                    color="primary"
                    type="submit"
                    disabled={isSubmitDisabled}
                  >
                    {translate(
                      'manageordersscreen.scheduleDeliverySection.onClickSubmit'
                    )}
                  </NewButton>
                </DialogPanelFooter>
              </Form>
            );
          }}
        </Formik>
      </DialogPanel>
    </div>
  );
}

PerformBulkActions.propTypes = {
  onCancelClick: PropTypes.func,
  translate: PropTypes.func,
  handleSubmit: PropTypes.func,
};

PerformBulkActions.defaultProps = {
  onCancelClick: () => {},
  translate: () => {},
  handleSubmit: () => {},
};

export default PerformBulkActions;
